import { render, staticRenderFns } from "./TabDialogue.vue?vue&type=template&id=4da1cae9&"
import script from "./TabDialogue.vue?vue&type=script&lang=js&"
export * from "./TabDialogue.vue?vue&type=script&lang=js&"
import style0 from "./TabDialogue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports